// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__V5zx2","inputDescription":"styles_inputDescription__20omw"};